import { render, staticRenderFns } from "./userBottom.vue?vue&type=template&id=6d3d1b3f&scoped=true"
import script from "./userBottom.vue?vue&type=script&lang=js"
export * from "./userBottom.vue?vue&type=script&lang=js"
import style0 from "./userBottom.vue?vue&type=style&index=0&id=6d3d1b3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3d1b3f",
  null
  
)

export default component.exports